import React from 'react'
import {
  List,
  Datagrid,
  Edit,
  SimpleForm,
  TextField,
  EditButton,
  Show,
  Filter,
  TextInput,
  TabbedShowLayout,
  Tab,
  FileInput,
  FileField,
  Create,
  required,
} from 'react-admin'
import HiddenUserInput from './HiddenUserInput'
import Attachments from './Attachments'

const ProductFilter = props => (
  <Filter {...props}>
    <TextInput source="name_contains" label="Name" alwaysOn />
    <TextInput source="id_contains" label="ID" />
    <TextInput source="description_contains" label="Description" />
  </Filter>
)

export const ProductList = props => {
  return (
    <List {...props} filters={<ProductFilter />}>
      <Datagrid rowClick="show">
        <TextField source="name" />
        <TextField source="description" />
        <EditButton />
      </Datagrid>
    </List>
  )
}

const ProductTitle = ({ record }) => {
  return <span>Product {record ? `"${record.name}"` : ''}</span>
}

export const ProductEdit = props => (
  <Edit title={<ProductTitle />} {...props}>
    <SimpleForm redirect="list">
      <TextInput source="name" validate={required()} />
      <TextInput multiline source="description" />
      <FileInput source="uploads" label="Attachments" multiple>
        <FileField source="url" title="name" />
      </FileInput>
      <HiddenUserInput {...props} />
    </SimpleForm>
  </Edit>
)

export const ProductShow = props => (
  <Show title={<ProductTitle />} {...props}>
    <TabbedShowLayout>
      <Tab label="summary">
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="description" />
      </Tab>
      <Tab label="Attachments" path="attachments">
        <Attachments />
      </Tab>
    </TabbedShowLayout>
  </Show>
)

export const ProductCreate = props => {
  return (
    <Create title="Create Product" {...props}>
      <SimpleForm redirect="list">
        <TextInput source="name" validate={required()} />
        <TextInput source="description" />
        <HiddenUserInput {...props} />
      </SimpleForm>
    </Create>
  )
}
